module.exports = __webpack_public_path__ + "static/media/Healthcare_Hero_03.98c8a1cf.jpg";